module.exports = __webpack_public_path__ + "assets/img/fone-de-ouvido.b7627519.png";